// @ts-nocheck

import React, { useMemo, useState } from 'react';
import styled, { css } from 'styled-components';

import { useViewportContext } from '../../../../contexts/ViewportContext';
import useModalContext from '../../../../hooks/useModalContext';
import { computeAppBarHeight } from '../../../../utils/layout';
import { MPBackgroundImg } from '../../assets/img';
import { MPViewContext } from '../../contexts/MPViewContext';

const Wrapper = styled.div`
  padding: 1em;
  position: relative;
  transform: translateZ(0);

  ${({ $availableHeight, $availableWidth }) => css`
    width: ${$availableWidth ? `${$availableWidth}px` : '100%'};
    min-height: ${$availableHeight ? `${$availableHeight}px` : '100%'};
    height: ${({ $fixHeight, $availableHeight }) => ($fixHeight ? `${$availableHeight}px` : 'auto')};
  `}
`;

const Background = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  background-color: #0a415c;
  background-image: url(${MPBackgroundImg});
  background-position: top center fixed;
  background-repeat: no-repeat;
  background-size: 100% auto;

  filter: var(--MPViewWrapper-filter, none);

  transition: filter 300ms ease-in-out;
`;

type MPViewWrapperProps = {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  noScroll?: boolean;
};

const MPViewWrapper = ({ className = '', children, onClick, noScroll = false }: MPViewWrapperProps) => {
  const { height, ratio, domNodeRef } = useViewportContext();
  const { height: modalHeight, width: modalWidth } = useModalContext();
  const [fixScroll, setFixScroll] = useState(noScroll);

  const { navbarHeight, tabbarHeight } = useMemo(
    () => (ratio && domNodeRef && domNodeRef.current ? computeAppBarHeight(ratio, domNodeRef.current) : {}),
    [ratio, domNodeRef],
  );

  const availableHeight = useMemo(
    () => (modalHeight ? modalHeight : height - navbarHeight - tabbarHeight),
    [height, modalHeight, navbarHeight, tabbarHeight],
  );

  const providedState = useMemo(
    () => ({ height: availableHeight, fixScroll, setFixScroll }),
    [availableHeight, fixScroll],
  );

  return (
    <Wrapper
      id="mp-view-wrapper"
      className={className}
      $availableWidth={modalWidth}
      $availableHeight={availableHeight}
      $fixHeight={fixScroll}
      onClick={onClick}
    >
      <Background />
      <MPViewContext.Provider value={providedState}>{children}</MPViewContext.Provider>
    </Wrapper>
  );
};

export default MPViewWrapper;
